var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#EEF0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 34.6673C27.2924 34.6673 26.6142 34.3864 26.1141 33.8863C25.614 33.3862 25.333 32.7079 25.333 32.0007C25.333 30.5207 26.5197 29.334 27.9997 29.334C28.7069 29.334 29.3852 29.6149 29.8853 30.115C30.3854 30.6151 30.6663 31.2934 30.6663 32.0007C30.6663 32.7079 30.3854 33.3862 29.8853 33.8863C29.3852 34.3864 28.7069 34.6673 27.9997 34.6673ZM35.9997 38.6673V25.334H19.9997V38.6673H35.9997ZM35.9997 22.6673C36.7069 22.6673 37.3852 22.9483 37.8853 23.4484C38.3854 23.9485 38.6663 24.6267 38.6663 25.334V38.6673C38.6663 39.3746 38.3854 40.0528 37.8853 40.5529C37.3852 41.053 36.7069 41.334 35.9997 41.334H19.9997C19.2924 41.334 18.6142 41.053 18.1141 40.5529C17.614 40.0528 17.333 39.3746 17.333 38.6673V25.334C17.333 23.854 18.5197 22.6673 19.9997 22.6673H21.333V20.0007C21.333 18.2325 22.0354 16.5368 23.2856 15.2866C24.5359 14.0364 26.2316 13.334 27.9997 13.334C28.8752 13.334 29.7421 13.5064 30.5509 13.8415C31.3597 14.1765 32.0947 14.6675 32.7137 15.2866C33.3328 15.9057 33.8238 16.6406 34.1589 17.4494C34.4939 18.2583 34.6663 19.1252 34.6663 20.0007V22.6673H35.9997ZM27.9997 16.0007C26.9388 16.0007 25.9214 16.4221 25.1712 17.1722C24.4211 17.9224 23.9997 18.9398 23.9997 20.0007V22.6673H31.9997V20.0007C31.9997 18.9398 31.5782 17.9224 30.8281 17.1722C30.078 16.4221 29.0605 16.0007 27.9997 16.0007Z",
    fill: "#394141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.2127528b988733a2e90672a178162e4b.svg";
export { ForwardRef as ReactComponent };